import { FC, useState } from 'react';

import { Close } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Formik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { useParams } from '@redwoodjs/router';
import { useMutation } from '@redwoodjs/web';

import { Flex } from 'src/components/Flex';
import { CustomRadioGroup, FieldInput } from 'src/components/FormikComponents';
import { ModalBox } from 'src/components/ModalContent/Modal';
import { showSuccessToast } from 'src/components/Toasts/toast';
import { CANCEL_SALES_INVOICE } from 'src/graphql/mutations/cancelSalesInvoice.mutation';
import { onError } from 'src/utils/utils';
import { CancelSalesInvoiceValidation } from 'src/validation/SalesInvoice';

export const CancelSalesInvoice: FC = () => {
    const { id } = useParams();
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    const [cancelSalesInvoice] = useMutation(CANCEL_SALES_INVOICE, {
        onError,
        onCompleted: (data) => {
            const salesInvoiceId = data?.cancelSalesInvoice;

            if (salesInvoiceId) {
                showSuccessToast('Sales invoice canceled');
                navigate('/finance/sales-invoices', { replace: true });
            }
        },
    });

    return (
        <>
            <Flex
                justifyContent="center"
                alignItems="center"
                color="white"
                bgcolor="#F39E4E"
                borderRadius="4px"
                padding="8px"
                sx={{ cursor: 'pointer' }}
                onClick={() => setShowModal(true)}
                data-testid="cancel-sales-invoice-button"
            >
                <Close height="24px" width="24px" />
            </Flex>
            {showModal && (
                <ModalBox
                    handleCloseModal={() => setShowModal(false)}
                    open={showModal}
                    title="Confirm Invoice Cancellation"
                >
                    <Formik
                        initialValues={{
                            reason: '',
                            raiseCreditNote: 'YES',
                        }}
                        onSubmit={async ({ reason, raiseCreditNote }) => {
                            await cancelSalesInvoice({
                                variables: {
                                    input: {
                                        id,
                                        reason,
                                        raiseCreditNote: raiseCreditNote === 'YES',
                                    },
                                },
                            });
                        }}
                        validationSchema={CancelSalesInvoiceValidation}
                    >
                        {({ handleSubmit }) => (
                            <Flex gap="16px" flexDirection="column" padding="16px 8px">
                                <FieldInput
                                    name="reason"
                                    label="Reason for Cancelling"
                                    placeholder="Reason for Cancelling"
                                />
                                <CustomRadioGroup
                                    name="raiseCreditNote"
                                    options={[
                                        { label: 'Yes', value: 'YES' },
                                        { label: 'No', value: 'NO' },
                                    ]}
                                    label="Raise Credit Note?"
                                />
                                <Flex gap="8px">
                                    <Button onClick={() => setShowModal(false)} variant="main">
                                        Cancel
                                    </Button>
                                    <Button onClick={() => handleSubmit()} variant="main">
                                        Confirm
                                    </Button>
                                </Flex>
                            </Flex>
                        )}
                    </Formik>
                </ModalBox>
            )}
        </>
    );
};
